/* global cv */

import React, {useEffect} from 'react';
import './App.css';
import injectScript from './injectScript';
import processImage, { init } from './processImage';
import QRCode from 'react-qr-code';

let width = 320;
let height = 0;

let vc = null;
let src = null;

function startCamera(video, onDetectUI) {
  navigator.mediaDevices.getUserMedia({
    video: {
      facingMode: 'environment',
    }, 
    audio: false
  })
   .then(function(s) {
    video.srcObject = s;
    video.onloadedmetadata = () => {
      video.play();
    }
  })
    .catch(function(err) {
    console.log("An error occured! " + err);
  });

  video.addEventListener("canplay", function(ev){
    video.setAttribute("width",  video.videoWidth);
    video.setAttribute("height", video.videoHeight);
    width = video.videoWidth;
    height = video.videoHeight;
    vc = new cv.VideoCapture(video);
    startVideoProcessing(onDetectUI);
  }, false);
}

function startVideoProcessing(onDetectUI) {
  src = new cv.Mat(height, width, cv.CV_8UC4);
  init(width, height);
  requestAnimationFrame(() => processVideo(onDetectUI));
}

function processVideo(onDetectUI) {
  vc.read(src);
  let result = processImage(src, width, height);
  

  if (result.detected) {
    onDetectUI(result);
    cv.imshow("canvasTargetOutput", result.image);
    //TODO: ecken finden
  } else {
    cv.imshow("canvasOutput", result.image);
    requestAnimationFrame(() => processVideo(onDetectUI));
  }
}

const App = () => {
  const videoRef = React.useRef();
  const canvasRef = React.useRef();
  const targetCanvasRef = React.useRef();
  const [step, setStep] = React.useState('recording');
  const [grid, setGrid] = React.useState();
  const [selection, setSelection] = React.useState("");

  function stopStreamedVideo(videoElem) {
    const stream = videoElem.srcObject;
    console.log("Stream: ", stream);
    if (stream){
      const tracks = stream.getTracks();
      tracks.forEach(function(track){
        track.stop();
      });
    }
    videoElem.srcObject = null;
  }

  useEffect(
    () => {
      injectScript('opencv', 'opencv.js')
        .then(() => startCamera(videoRef.current, (result) => {
          stopStreamedVideo(videoRef.current);
          setGrid(result.grid);
          setStep("selection");
        }))
    }, []
  )

  function select(i) {
    setSelection(`https://iovent.net?app=artest&button=${i}`);
    setStep("qr")
  }


  return (
    <div className="videoWrapper">
      <video playsInline ref={videoRef} hidden />


      {/* Camera Page */}
      <div hidden={step!=='recording'} style={{width: '100%', height: '100%'}}>
        <div style={{width: '100%', height: '100%', position: 'absolute', textAlign: 'center'}}>
          <canvas ref={canvasRef} id="canvasOutput" style={{height:'100%'}}/>
        </div>
        <div style={{width: '100%', position: 'absolute', marginTop: '2em', textAlign: 'center'}}>
          <div style={{padding: '0.5em', background: '#00000080', color: '#fff', display: 'inline-block'}}>
            <b>Bitte halten Sie die Kamera vor den Automatenbildschirm,<br/>so dass alle Produkte zu sehen sind.</b>
          </div>
        </div>
      </div>


      {/* Selection Page */}
      <div hidden={step!=='selection'} >
        <div style={{width: '100%', height: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {/*<div hidden="true" style={{padding: 32}}>
            <b>Wählen Sie nun ihr Heißgetränk aus.</b>
          </div>*/}
        <div style={{display: 'flex', flexDirection: 'column', width: '100%', position: 'relative'}}>
          <canvas ref={targetCanvasRef} id="canvasTargetOutput" style={{'width': '100%'}}/>
          <div style={{position: 'absolute', width: '100%', height: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
            {
              grid && [...Array(grid.x * grid.y).keys()].map((i) => <div key={i} style={{width: `${100/grid.x}%`, height: `${100/grid.y}%`}} onClick={() => select(i)}></div>)
            }
          </div>
        </div>
        
          {/*<button
          style={{margin: 32, padding: '16px 32px', backgroundColor: '#555555', textDecoration: 'none', color: '#fff', border: 'none', display: 'inline-block'}}
          onClick={() => {
            setStep("recording");
            startCamera(videoRef.current, (result) => {
              videoRef.current.pause();
              setGrid(result.grid);
              setStep("selection");
          })}}>
          Zurück
        </button>*/}
        </div>
      </div>


      {/* QR Code Page */}
      <div hidden={step!=="qr"}>
        <div style={{width: '100%', textAlign: 'center', margin: '32px'}}>
          <div style={{border: '6px solid white', background: 'white', width: 192, display: 'inline-block'}}>
            <QRCode value={selection} size={192}/>
          </div><br/><br/>
          <button hidden={true}
                  style={{margin: 32, padding: '16px 32px', backgroundColor: '#555555', borderRadius: '8px', textDecoration: 'none', color: '#fff', border: 'none', display: 'inline-block'}}
                  onClick={() => {
                    setStep("recording");
                    startCamera(videoRef.current, (result) => {
                      stopStreamedVideo(videoRef.current);
                      setGrid(result.grid);
                      setStep("selection");
                    })}}>
            Zurück
          </button>
        </div>
      </div>


  </div>
  );  
  //
}

export default App;
